import React from "react";
import { useLocation, useHistory } from "react-router-dom";

import { Button, Layout, Space, PageHeader } from "antd";
import { useSelector } from "react-redux";

const { Content } = Layout;

export default function ThemePreview(props) {
  const location = useLocation();
  const history = useHistory();
  const adminRestaurant = useSelector((state) => state.admin);


  const isFoodLuvTrail = location.pathname
    ?.toString()
    .includes("foodluv-trial");


  return (
    <>
      {isFoodLuvTrail ? (
        <Layout className="u-page-layout">
          <Content>
            <Space
              direction="vertical"
              style={{
                width: "100%",
              }}
            >
              <PageHeader
              className="page-header-business"
                title={
                  <div className="flex items-center">
                    <div
                      className="cursor-pointer flex"
                      onClick={() => history.goBack()}
                    >
                      <svg
                        width="25"
                        height="16"
                        viewBox="0 0 25 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                    <div className="ml-1 ant-page-header-heading-title">
                      Preview Website
                    </div>
                  </div>
                }
                extra={[
                  <Button
                    type="primary"
                    className="custom-btn"
                    onClick={() => history.push('/foodluv-trial/publish-website')}
                  >
                    Publish
                  </Button>,
                ]}
              />
              <div className="content-container-business">
                <iframe
                  style={{ width: "100%", height: "calc(100vh - 280px)" }}
                  src="https://stgadmin.foodluv.io/"
                  title="Website Preview"
                ></iframe>
              </div>
            </Space>
          </Content>
        </Layout>
      ) : (
        <iframe
          style={{ width: "100%", height: "calc(100vh - 280px)" }}
          src={`${process.env.REACT_APP_MOBILE_APP_URL}/${adminRestaurant}`}
          title="Website Preview"
        ></iframe>
      )}
    </>
  );
}
